import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveContainer, LineChart, Line, CartesianGrid, YAxis} from 'recharts';
import classnames from 'classnames';

/**
 * This is a chart view that displays (intraday) data as a line chart. It's used within <GridItem />
 */
const SmallChart = (props) => {
    let data = [];

    if(Array.isArray(props.chartData)) {
        data = props.chartData;
    } else if(props.chartData?.intraday) {
        data = props.chartData.intraday;
    }

    const classNames = classnames('currency-pair-chart', props.className);

    return (
        <div className={classNames}  role="img" aria-hidden="true">
            <ResponsiveContainer>
                <LineChart data={data} margin={{ top: 2, bottom: 2, right: 2, left: 2 }}>
                    <CartesianGrid vertical={false} stroke="#4e9bcd" strokeDasharray="5 5"/>
                    <Line
                        type="linear"
                        dataKey="value"
                        stroke="#ffffff"
                        strokeWidth="1"
                        dot={{ stroke: '#2282c1', strokeWidth: 2 }}
                        isAnimationActive={false}
                    />
                    <YAxis
                        hide={true}
                        domain={['dataMin', 'dataMax']}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

SmallChart.propTypes = {

    /**
     * the data that should be displayed in the chart view
     */
    chartData: PropTypes.oneOfType([
        PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.number.isRequired
            })
        ),
        PropTypes.shape({
            intraday: PropTypes.array
    })
    ])
};

export default SmallChart;